var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: _vm.isUpgrade ? "Abonnement upgraden" : "Abonnement",
        "ok-disabled": !_vm.dataValid || _vm.purchasing,
        size: "xl",
        "ok-text": "Kostenpflichtig bestellen",
        "hide-actions": _vm.purchasing || !_vm.dataComplete,
        "hide-close": _vm.purchasing
      },
      on: {
        ok: _vm.onOk,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _vm.loading
        ? _c("Loading", { attrs: { text: "Lade Daten..." } })
        : [
            !_vm.dataComplete && _vm.customer
              ? _c("CompleteData", {
                  attrs: { customer: _vm.customer },
                  on: {
                    complete: function($event) {
                      _vm.dataComplete = true
                    }
                  }
                })
              : [
                  _vm.purchasing
                    ? _c("Loading", {
                        staticClass: "mt-4",
                        attrs: {
                          text:
                            "Die Bestellung wird initialisiert, bitte schließe das Browserfenster nicht!"
                        }
                      })
                    : [
                        _c(
                          "div",
                          { staticClass: "mb-5" },
                          [
                            _c("h4", [_vm._v("So funktioniert's:")]),
                            _vm._v(" "),
                            _c("HowItWorks", {
                              staticClass: "my-4",
                              attrs: { "on-white": true }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("PriceTable", {
                          attrs: {
                            "with-free": false,
                            "custom-button-click-handler": "",
                            "chosen-product": _vm.product,
                            "upgradable-items": _vm.upgradableItems
                          },
                          on: { buy: _vm.onChoseProduct }
                        }),
                        _vm._v(" "),
                        _vm.product
                          ? [
                              _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-bold font-size-big4 mb-2"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { class: "color-" + _vm.productColor },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.product.label) + ":"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("moneyAmount")(
                                                _vm.priceToPay.price
                                              )
                                            ) +
                                            " (inkl. " +
                                            _vm._s(_vm.priceToPay.taxRate) +
                                            "% USt.)\n\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasMollieCustomerId
                                    ? [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\tNach Klick auf "
                                        ),
                                        _c("b", [
                                          _vm._v("Kostenpflichtig bestellen")
                                        ]),
                                        _vm._v(
                                          " buchen wir den Betrag automatisch von\n\t\t\t\t\t\t\tder\n\t\t\t\t\t\t\tvon dir gewählten Zahlungsmethode ab. Sollte das nicht funktionieren, wirst du auf die\n\t\t\t\t\t\t\tSeite\n\t\t\t\t\t\t\tunseres Zahlungsdienstleisters (MOLLIE) weitergeleitet, wo du aus verschiedenen\n\t\t\t\t\t\t\tZahlungsarten wählen kannst.\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\tNach Klick auf "
                                        ),
                                        _c("b", [
                                          _vm._v("Kostenpflichtig bestellen")
                                        ]),
                                        _vm._v(
                                          " wirst du auf die Seite unseres\n\t\t\t\t\t\t\tZahlungsdienstleisters (MOLLIE) weitergeleitet, wo du aus verschiedenen Zahlungsarten\n\t\t\t\t\t\t\twählen\n\t\t\t\t\t\t\tkannst.\n\t\t\t\t\t\t"
                                        )
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "payment-logos mt-3" }, [
                                _c(
                                  "ul",
                                  _vm._l(_vm.paymentMethods, function(method) {
                                    return _c("li", { key: method.key }, [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/img/payment/method/" +
                                            method.key +
                                            ".svg",
                                          alt: method.name
                                        }
                                      })
                                    ])
                                  }),
                                  0
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c("PrivacyCheckbox", {
                                    model: {
                                      value: _vm.privacy,
                                      callback: function($$v) {
                                        _vm.privacy = $$v
                                      },
                                      expression: "privacy"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.error
                          ? _c(
                              "InfoBox",
                              { staticClass: "mt-4", attrs: { type: "error" } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\tBei der Bezahlung ist ein Fehler aufgetreten. Bitte versuche es erneut oder wende dich an\n\t\t\t\t\tunseren "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.openFeedback.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Support")]
                                ),
                                _vm._v(".\n\t\t\t\t")
                              ]
                            )
                          : _vm._e()
                      ]
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }